var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-select',{attrs:{"options":_vm.internalOptions,"clearable":false,"filterable":false,"searchable":false,"multiple":_vm.multiple,"value":_vm.getValue(),"placeholder":_vm.placeholder,"disabled":_vm.isDisabled},on:{"input":_vm.onChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }